import { cn } from "@/lib/utils";
import { cva } from "class-variance-authority";
const tagVariants = cva(
  "h-[30px]  py-[2px] px-2 rounded text-[14px] md:text-[15px] leading-[150%] wireless-Medium rounded inline-flex items-center justify-center",
  {
    variants: {
      type: {
        error: "bg-system-disableError text-system-error",
        warning: "bg-system-disableWarning text-system-warning",
        success: "bg-system-disableSuccess text-system-success",
      },
    },
  }
);

export default function Tag({ label, type }) {
  return <span className={cn(tagVariants({ type }))}>{label}</span>;
}
